import React from "react";
import { useState } from "react";
import { FaArrowLeft, FaQrcode, FaRegCommentDots, FaTimesCircle, FaThermometerHalf } from "react-icons/fa";
import len from "../../assets/svg/lentra.svg";
import gate from "../../assets/svg/gateout.svg";
import clck from "../../assets/svg/clock.svg";
import TopBar from "../topbar/TopBar";
import qr from "../../assets/svg/qr.svg";
import download from "../../assets/svg/download.svg";
import print from "../../assets/svg/print.svg";
import mail from "../../assets/svg/mail.svg";
import mobile from "../../assets/svg/mobile.svg";
import limited from "../../assets/svg/limited.svg";
import location from "../../assets/svg/location.svg";
import proofphn from "../../assets/svg/proofphn.svg";
import direct from "../../assets/svg/direct.svg";
import business from "../../assets/svg/business.svg";
import aadhar from "../../assets/svg/aadhaar.svg";
import production from "../../assets/svg/production.svg";
import name from "../../assets/svg/name.svg";
import mnumber from "../../assets/svg/mnumber.svg";
import age from "../../assets/svg/age.svg";
import relation from "../../assets/svg/relation.svg";
import proof from "../../assets/svg/Proof.svg";
import invoice from "../../assets/svg/invoice.svg";
import abilash from "../../assets/svg/abilash.svg";
import saran from "../../assets/svg/saran.svg";
import santhosh from "../../assets/svg/santhosh.svg";
import meenaktchi from "../../assets/svg/meenaktchi.svg";
function Vehicleview() {
  const [activeTab, setActiveTab] = useState("items");
  const guestsData = [
    {
      name: "Abilash Zibrahim",
      mobile: "+919876543210",
      age: 23,
      relation: "Father",
      proof: "707603623600",
      image: abilash,
    },
    {
      name: "Saran Kumar",
      mobile: "+919876543210",
      age: 23,
      relation: "Father",
      proof: "707603623600",
      image: saran,
    },
    {
      name: "Santhosh Kumar",
      mobile: "+919876543210",
      age: 23,
      relation: "Father",
      proof: "707603623600",
      image: santhosh,
    },
    {
      name: "Meenakchi Sundaram",
      mobile: "+919876543210",
      age: 23,
      relation: "Father",
      proof: "707603623600",
      image: meenaktchi,
    },
  ];
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div>
        <TopBar />
      </div>

      <div style={{ fontFamily: "Epilogue", padding: "20px", backgroundColor: "#f5f5f5" }}>
        {/* Header Section */}
        <div style={{ display: "flex", flexDirection: "column", padding: "10px 20px", backgroundColor: "#fff", borderRadius: "8px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {/* Left Section: Back Button, Profile Icon, Name, Company */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaArrowLeft style={{ fontSize: "18px", marginRight: "15px", cursor: "pointer" }} />
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ width: "35px", height: "35px", backgroundColor: "#2d3748", color: "#fff", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px", fontWeight: "bold", marginRight: "10px" }}>J</div>
                <div>
                  <h2 style={{ margin: "2px 0px", fontSize: "16px", fontWeight: "bold" }}>Jeason Statham</h2>
                  <p style={{ color: "#555", display: "flex", alignItems: "center", fontSize: "13px", margin: "2px 0px", fontWeight: "500" }}>
                    TN 09 AB 9769 &nbsp;•&nbsp;
                    <span style={{ background: "#EDE9FE", color: "#7C3AED", padding: "2px 8px", borderRadius: "12px", fontSize: "12px", fontWeight: "600" }}>20 feet truck</span>
                  </p>
                </div>
              </div>
            </div>

            {/* Right Section: QR Code & Acknowledgement Buttons */}
            <div style={{ display: "flex", gap: "10px", fontWeight: "500" }}>
              <button style={{ display: "flex", alignItems: "center", backgroundColor: "#f5f5f5", border: "1px solid #ddd", padding: "8px 12px", borderRadius: "12px", cursor: "pointer", fontSize: "14px", fontWeight: "500" }}>
                <FaQrcode style={{ marginRight: "5px" }} /> Generate QR
              </button>
              <button style={{ display: "flex", alignItems: "center", backgroundColor: "#f5f5f5", border: "1px solid #ddd", padding: "8px 12px", borderRadius: "12px", cursor: "pointer", fontSize: "14px", fontWeight: "500" }}>
                <FaRegCommentDots style={{ marginRight: "5px" }} /> Acknowledgement
              </button>
            </div>
          </div>

          {/* Gate-in, Duration, and Gate-out Section */}
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px dotted #ddd",
              padding: "10px",
              borderRadius: "20px",
              position: "relative",
            }}>
            {/* Gate In */}
            <div
              style={{
                border: "dashed 2px black",
                backgroundColor: "#fff",
                padding: "5px 15px",
                borderRadius: "20px",
                fontSize: "13px",
                fontWeight: "400",
                display: "flex",
                alignItems: "center",
                position: "relative",
                zIndex: 2,
              }}>
              Gate in : <span style={{ fontWeight: "600", marginLeft: "5px" }}>23 Feb 2025 at 05:05 PM</span>
            </div>

            {/* Dashed Connecting Line */}
            <div
              style={{
                flexGrow: 1,
                height: "2px",
                borderTop: "2px dashed black",
                margin: "0 10px",
                position: "relative",
                top: "0px",
                zIndex: 1,
              }}></div>

            {/* Time Duration */}
            <div
              style={{
                backgroundColor: "#f0fff0",
                padding: "5px 15px",
                borderRadius: "20px",
                fontSize: "14px",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                border: "1px solid #a3d9a5",
                position: "relative",
                zIndex: 2,
              }}>
              <img src={clck} alt="" /> 00:30:48 hrs
            </div>

            {/* Dashed Connecting Line */}
            <div
              style={{
                flexGrow: 1,
                height: "2px",
                borderTop: "2px dashed black",
                margin: "0 10px",
                position: "relative",
                top: "0px",
                zIndex: 1,
              }}></div>

            {/* Gate Out */}
            {activeTab === "items" ? (
              <button
                style={{
                  border: "dashed 2px black",
                  backgroundColor: "#4caf50",
                  color: "#fff",
                  padding: "8px 20px",
                  borderRadius: "20px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                  zIndex: 2,
                }}>
                <img src={gate} alt="" /> Gate out
              </button>
            ) : (
              <button style={{}}>gate out:23 Feb 2025 at 05:05 PM</button>
            )}
          </div>
        </div>

        <div style={{ display: "flex" }}>
          {/* Visitor Details Section */}
          {activeTab === "items" ? (
            <div style={{ marginTop: "20px", padding: "20px", backgroundColor: "#fff", borderRadius: "8px", width: "400px", height: "889px" }}>
              <h3 style={{ marginBottom: "10px", fontSize: "16px", fontWeight: "700" }}>Visitor Details</h3>
              <p>
                <img src={mail} alt="" /> jeasonstatham456@gmail.com
              </p>
              <p>
                <img src={mobile} alt="" /> +91-9876543210
              </p>
              <p>
                <img src={limited} alt="" /> Lentera Technologies Private Limited
              </p>
              <p>
                <img src={direct} alt="" /> Direct Meeting
              </p>
              <p>
                <img src={location} alt="" /> Chennai
              </p>
              <h4 style={{ marginTop: "15px", fontSize: "14px", fontWeight: "bold" }}>Proof Details</h4>
              <p>
                <img src={proofphn} alt="" /> DL4543TF64535 - <span style={{ borderRadius: "10px", background: "#F1F2F4" }}>Driving license</span>
              </p>
              <p fontFamily="Epilogue,sans-serif" style={{ color: "#a0a0a0" }}>
                Attachments:3
              </p>
              <div style={{ padding: "5px", display: "flex", flexDirection: "column", gap: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    background: "#F7F8F9",
                    borderRadius: "10px",
                    padding: "10px",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    width: "300px",
                  }}>
                  <img src={aadhar} alt="Aadhaar" style={{ width: "40px", height: "40px", borderRadius: "5px" }} />
                  <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                    <span style={{ fontWeight: "bold", color: "#1D2939" }}>Aadhaar phot.png</span>
                    <span style={{ fontSize: "12px", color: "#98A2B3" }}>2.34 MB</span>
                  </div>
                  <a href="#" style={{ color: "#027A48", fontWeight: "bold", textDecoration: "none" }}>
                    View
                  </a>
                </div>
              </div>
              <h4>Acknowledgement</h4>
              <p>Thank you for registering your visit. Your check-in details have been successfully recorded.Please proceed to the reception for further assistance </p>
            </div>
          ) : (
            <div style={{ width: "700px" }}></div>
          )}

          {/* Right side container */}
          <div style={{ marginTop: "20px", display: "flex", flexWrap: "wrap", gap: "20px", marginLeft: "10px", maxWidth: "75%", maxHeight: "fit-content" }}>
            {/* Box 1 */}
            <div
              style={{
                borderRadius: "10px",
                padding: "16px",
                width: "280px",
                fontFamily: "Inter, sans-serif",
                backgroundColor: "#FFFFFF",
                boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                flexBasis: "32%",
              }}>
              <h4 style={{ margin: "0 0 12px 0", color: "#0F172A", fontWeight: "600", fontSize: "14px" }}>Visit details</h4>

              {/* Business Meeting Tag */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#EAFBE7",
                  padding: "6px 10px",
                  borderRadius: "8px",
                  fontSize: "18px",
                  fontWeight: "700px",
                  color: "#164B16",
                  border: "1px solid #C0E6C0",
                  width: "fit-content",
                }}>
                <img src={business} alt="Flag" style={{ marginRight: "6px" }} /> Business meeting
              </div>

              {/* Meeting Person Title */}
              <p style={{ color: "#8790A1", marginTop: "16px", fontSize: "12px", fontWeight: "400" }}>Department</p>

              {/* Profile Section (VERTICAL ALIGNMENT) */}
              <div style={{ display: "flex", flexDirection: "column", alignItems: "start", gap: "8px" }}>
                <p
                  style={{
                    margin: "0",
                    fontSize: "12px",
                    color: "#64748B",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}>
                  <img src={production} alt="" style={{ width: "14px", height: "14px" }} /> Production & Manufacturing
                </p>
                <p style={{ color: "#8790A1", marginTop: "16px", fontSize: "12px", fontWeight: "400" }}>Bill or Invoice</p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    background: "#f7f7f7",
                    padding: "10px",
                    borderRadius: "10px",
                    width: "320px",
                    fontFamily: "Arial, sans-serif",
                  }}>
                  <img
                    src={invoice} // Replace with actual image
                    alt="file preview"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "5px",
                      marginRight: "10px",
                    }}
                  />
                  <div style={{ flex: 1 }}>
                    <p style={{ margin: "0", fontSize: "14px", fontWeight: "bold" }}>Invoice345.pdf</p>
                    <p style={{ margin: "0", fontSize: "12px", color: "#888" }}>2.34 MB</p>
                  </div>
                  <a
                    href="#"
                    style={{
                      color: "green",
                      fontWeight: "bold",
                      textDecoration: "none",
                    }}>
                    View
                  </a>
                </div>
              </div>
            </div>

            {/* Box 2 */}
            <div
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "10px",
                padding: "16px",
                width: "322.67px",
                fontFamily: "Arial, sans-serif",
                backgroundColor: "#fff",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
                flexBasis: "32%",
              }}>
              <h4 style={{ margin: "0 0 10px 0", color: "#172B4D", textAlign: "left" }}>QR code</h4>
              <img src={qr} alt="QR Code" style={{ marginBottom: "10px", borderRadius: "5px" }} />
              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                <button
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#f5f5f5",
                    border: "1px solid #ddd",
                    padding: "8px 12px",
                    borderRadius: "12px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500",
                    gap: "16px",
                  }}>
                  <img src={download} alt="" /> Download
                </button>
                <button
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#f5f5f5",
                    border: "1px solid #ddd",
                    padding: "8px 12px",
                    borderRadius: "12px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}>
                  <img src={print} alt="" /> Print
                </button>
              </div>
            </div>

            {/* Box 3 */}
            <div
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "16px",
                padding: "16px",
                width: "322.67px",
                flexBais: "32%",
                fontFamily: "Arial, sans-serif",
                backgroundColor: "#fff",
              }}>
              <h4 style={{ margin: "0 0 10px 0", color: "#333" }}>Check list</h4>
              <div
                style={{
                  backgroundColor: "#ffeeee",
                  padding: "10px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginBottom: "8px",
                }}>
                <FaTimesCircle style={{ color: "red" }} />
                <span style={{ fontWeight: "bold", color: "#333" }}>Druken</span>
              </div>
              <div
                style={{
                  backgroundColor: "#ffeeee",
                  padding: "10px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginBottom: "8px",
                }}>
                <FaTimesCircle style={{ color: "red" }} />
                <span style={{ fontWeight: "bold", color: "#333" }}>Have a weapon</span>
              </div>
              <div
                style={{
                  backgroundColor: "#ffeeee",
                  padding: "10px",
                  borderRadius: "8px",
                  display: "flex",
                  flexBasis: "30px",
                  alignItems: "center",
                  gap: "8px",
                }}>
                <FaThermometerHalf style={{ color: "green" }} />
                <span style={{ fontWeight: "bold", color: "#333" }}>Temperature - 37°C</span>
              </div>
            </div>
            <div style={{ padding: "20px", background: "#FFFFFF", borderRadius: "10px", flexGrow: 1 }}>
              <h2 style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "10px" }}>Items : {guestsData.length}</h2>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  background: "white",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}>
                <thead>
                  <tr style={{ background: "#e2e8f0", textAlign: "left" }}>
                    <th style={{ padding: "10px", fontSize: "14px", fontWeight: "bold", borderBottom: "2px solid #cbd5e1" }}>Name</th>
                    <th style={{ padding: "10px", fontSize: "14px", fontWeight: "bold", borderBottom: "2px solid #cbd5e1" }}>Mobile Number</th>
                    <th style={{ padding: "10px", fontSize: "14px", fontWeight: "bold", borderBottom: "2px solid #cbd5e1" }}>Age</th>
                    <th style={{ padding: "10px", fontSize: "14px", fontWeight: "bold", borderBottom: "2px solid #cbd5e1" }}>Relation Type</th>
                    <th style={{ padding: "10px", fontSize: "14px", fontWeight: "bold", borderBottom: "2px solid #cbd5e1" }}>Proof</th>
                  </tr>
                </thead>
                <tbody>
                  {guestsData.map((item) => (
                    <tr key={item.id} style={{ borderBottom: "1px solid #e2e8f0" }}>
                      <td style={{ padding: "12px", fontSize: "14px", display: "flex", alignItems: "center" }}>
                        <img src={item.image} alt={item.name} style={{ width: "35px", height: "35px", borderRadius: "50%", marginRight: "10px" }} />
                        {item.name}
                      </td>
                      <td style={{ padding: "12px", fontSize: "14px" }}>{item.mobile}</td>
                      <td style={{ padding: "12px", fontSize: "14px" }}>{item.age}</td>
                      <td style={{ padding: "12px", fontSize: "14px" }}>{item.relation}</td>
                      <td style={{ padding: "12px", fontSize: "14px" }}>
                        {item.proof} &nbsp;
                        <button
                          style={{
                            backgroundColor: "#F1F2F4",
                            color: "#172B4D",
                            padding: "5px 10px",
                            borderRadius: "5px",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "12px",
                          }}>
                          Aadhaar
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Vehicleview;
